// extracted by mini-css-extract-plugin
export default {"loaderWrapper":"loader_loaderWrapper__+RKht","loader":"loader_loader__4V8ad","loaderAnimation":"loader_loaderAnimation__GZRhc","hidden":"loader_hidden__hnzG6"};